export enum SpiceEnum {
  Ulazna = 'Ulazna',
  Izlazna = 'Izlazna',
}



// WEBPACK FOOTER //
// ./src/app/enums/spice.enum.ts